<template>
  <div class="create-fishery" :class="{fishery:!hasName}">
    <h3>欢迎使用渔管理系统，请先创建渔场</h3>
    <div class="user" v-if="hasName==true">请在<a :href="url.center"  target="_blank">用户中心</a>补充姓名和昵称后<a @click="refresh" href="javascript:;">重新登录</a></div>
    <div class="create-contain">
      <el-form ref="baseForm" :model="baseForm" :rules="rules">
        <el-form-item class="general" label="渔场名称" prop="name">
          <!-- <label>渔场名称</label> -->
          <el-select v-if="haveCompany" v-model="baseForm.name" filterable placeholder="请选择" @change="changeEnterprise">
            <el-option
              v-for="item in fisheryList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input v-else v-model="baseForm.name" type="text" :maxlength="num50" placeholder="" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <!-- <label>所在地区</label> -->
          <el-form-item  label="所在地区" required>
            <div class="p-address">
              <el-col :span="8">
                <el-form-item prop="areaId">
                  <el-select v-model="baseForm.provinceNo" :disabled="haveCompany" placeholder="请选择省份" size="medium" style="width:100%;" @change="selectProvince" >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo" v-if="citys.length>0">
                  <el-select v-model="baseForm.cityNo" :disabled="haveCompany" placeholder="请选择市" size="medium" style="width:100%;" @change="selectCity">
                    <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo" v-if="countys.length>0" >
                  <el-select v-model="baseForm.countyNo" :disabled="haveCompany" placeholder="请选择县" size="medium" style="width:100%;">
                    <el-option v-for="item in countys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            
          </el-form-item>
        </el-row>
        <el-form-item class="general"  label="详细地址" prop="address">
          <el-input v-model="baseForm.address" :disabled="haveCompany" type="text" :maxlength="num50" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </el-form-item>
        <el-form-item class="general"  label="渔场负责人" prop="leader">
          <el-input v-model="baseForm.leader" disabled type="text" :maxlength="num50" placeholder="" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </el-form-item>
        <el-form-item class="save-cancel">
          <el-button class="save-btn" @click="createBase('baseForm')">立即创建</el-button>
          <el-button class="cancel-btn" style="margin-left:25px;color:#333;border:1px solid rgba(187, 187, 187, 1);border-radius:5px;font-size:14px;" @click="cancel('baseForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../store";
import url from "@/service/base-url";
export default {
  name: "CreateFishery",
  data() {
    return {
      url: url,
      num50: 50,
      haveCompany: "",
      citys: [],
      countys: [],
      // 公司选项
      options: [],
      // 参数
      baseForm: {
        id: "",
        name: "",
        leader: "", // 联系人
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        address: "" // 详细地址
      },
      findObj: {},
      // 校验规则
      rules: {
        name: [
          {
            required: true,
            message: "请先输入渔场名称",
            trigger: "blur"
          }
        ],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        address: [
          { required: false, message: "请先输入详细地址" }
          // {
          //   pattern: /^[0-9a-zA-Z\u4e00-\u9fa5]{2,40}$/,
          //   message: "详细地址格式不对,请重新输入"
          // }
        ]
      }
    };
  },
  async mounted() {
    this.getProvinces();
    this.options = await this.getCompanyInfo();
    this.options.push({ name: "自定义", id: "customize" });
    if (this.options && this.options.length !== 0) {
      this.haveCompany = true;
    } else {
      this.haveCompany = false;
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    ...mapState(modules.area, {
      provinces: "provinces"
    }),
    fisheryList() {
      return this.options;
    },
    // 个人中心是否有姓名与昵称
    hasName() {
      if (this.loginUser.name == "" || this.loginUser.nickName == "") {
        // console.log(333, this.loginUser.nickName);
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    ...mapActions(modules.account, {
      getCompanyInfo: "getCompanyInfo", //企业信息
      addUserCompany: "addUserCompany"
    }),

    // 刷新当前页面
    refresh() {
      window.location.reload();
    },
    // 切换渔场
    async changeEnterprise(e) {
      if (this.options.length !== 0) {
        // 是否选择自定义
        if (e == "customize") {
          this.baseForm = {
            id: "",
            name: "",
            leader: "", // 联系人
            provinceNo: "", // 省份
            cityNo: "", // 城市
            countyNo: "", // 辖区
            address: "" // 详细地址
          };
          this.citys = [];
          this.countys = [];
          this.haveCompany = false;
          if (this.loginUser.name != "") {
            this.baseForm.leader = this.loginUser.name;
          } else {
            this.baseForm.leader = this.loginUser.nickName;
          }
        } else {
          this.findObj = this.options.find(item => {
            return item.id == e;
          });
          this.baseForm.id = this.findObj.id;
          if (this.findObj.name != "") {
            this.baseForm.name = this.findObj.name;
          } else {
            this.baseForm.name = this.loginUser.nickName;
          }

          this.baseForm.address = this.findObj.address;
          this.baseForm.leader = this.findObj.creatorName;
          this.baseForm.provinceNo = this.findObj.province;
          await this.selectProvince();
          this.baseForm.cityNo = this.findObj.city;
          await this.selectCity();
          this.baseForm.countyNo = this.findObj.country;
          this.getProvinces();
        }
      }
    },
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForm.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForm.cityNo = null;
      this.baseForm.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForm.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForm.countyNo = null;
    },
    //取消
    cancel() {
      this.$router.push({
        name: "home",
        params: {
          reload: this.reload
        }
      });
    },
    // 提交
    createBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.addUserCompany({
            enterpriseId: this.baseForm.id,
            enterpriseName: this.baseForm.name,
            provinceId: this.baseForm.provinceNo,
            cityId: this.baseForm.cityNo,
            countryId:
              this.baseForm.countyNo == null ? 0 : this.baseForm.countyNo,
            address: this.baseForm.address,
            learder: this.baseForm.learder
          })
            .then(() => {
              this.$message({
                message: "成功创建渔场",
                type: "success"
              });
              parent.location.href = `${window.location.origin}`;
            })
            .catch(err => {
              if (err.response.data == "注册公司失败：原因：组织已经存在") {
                err.response.data = "渔场名称已被使用";
              }
              this.$message({
                message: err.response.data,
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>
<style lang="stylus">

.create-fishery{
  position :absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
  margin:auto;
  overflow :hidden;
  border-radius:10px;
  width:760px;
  height:580px;
  background :white;
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    font-size :16px;
    color:B0B0B0;
  }
  .el-form{
    margin-top:38px;
    margin-left:20px;
    padding:15px 60px 30px 60px;
    border-radius:5px;
    background :white;
    .general {
      .el-input__inner{
        
        width :500px;
        height 44px;

        line-height 44px;
        color:#333;
      }
    }
    .el-input__inner{
      height 44px;
      border:1px solid #e0e0e0;
      line-height 44px;
      font-size :16px;
    }
    .p-address{
      width :505px;
      height:44px;
    }
  }
  .is-disabled{
    .el-input__inner{
      border:1px solid #e0e0e0;
      color:#999 !important;
      background : #f3f3f3;
    }
  }
  .el-select .el-input .el-select__caret{
    position relative;
  }
  .el-icon-arrow-up:before {
    position:absolute;
    bottom:19px;
    right:8px;
    content:'';
    color:#666;
    width :11px;
    height:6px;
    background:url("../../assets/images/qualityTracing/input_down.png") no-repeat;
    transform:rotate(180deg);
  }
  .el-form .el-form-item .el-form-item__label:before{
    content:'';
    width :10px;
    height:10px;
    top:17px;
    left:-20px;
    background:url("../../assets/images/qualityTracing/star.png") no-repeat;
  }
  .el-form-item{
    margin-bottom:25px;
  }
  .el-form-item__content{
    display flex;
  }
  .el-form-item__label{
    width:107px;
    margin-right:0px;
    padding:0;
    line-height: 44px;
    font-size :16px;
    color:#666;
  }
  .el-button{
    width :100px;
    margin-left:107px;
    margin-top:20px;
    font-size :14px;
    color:white;
    span{
      vertical-align baseline;
    }
  }
}
.fishery{
  height:518px;
  .el-form{
    margin-top:30px;
  }
}
</style>

<style lang="stylus" scoped>
.create-fishery{
    h3{
      line-height:80px;
      text-align:center;
      font-size :28px;
      font-weight :bold;
      color:#fff;
      text-shadow:0px 2px 0px rgba(7,86,177,0.58);
      background:linear-gradient(-90deg,rgba(51,137,255,1),rgba(49,170,255,1));
    }
  .user{
    margin-top:38px;
    line-height :1;
    font-size :16px;
    color:#333;
    text-align:center;
    a{
      color:#1E72E6;
      text-decoration :underline;
    }
  }
}
</style>
